import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_kitchen_tabletop_decor: FaireCategoryEntity = {
  token: "cat_kitchen-tabletop-decor",
  type: "category",
  name: "Tabletop decor",
  level: 3,
  parentToken: "cat_home-decor-kitchen-tabletop",
  href: "/category/home-decor/kitchen-tabletop/tabletop-decor",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
